<div>
    <p class="rps-paragraph-one rps-mark-bold">
        <a href="javascript:void(0)" class="strategy-filter-link" role="button" tabindex="0"
            aria-label="strategyFilterDescriptionLink" (click)="simpleModalDialog.openModalDialog();"
            aria-label="What is strategy dialog">What's a strategy?</a>
    </p>
    <div class="filter--checkboxes">
        <p>
            <c11n-checkbox-group *ngIf="productType !== '529-portfolios'">
                <c11n-checkbox *ngFor="let label of strategyFilters" [labelText]="filterMap[label]">
                    <input c11nCheckboxInput [id]="label" type="checkbox" name="choices" [value]="label"
                        [formControl]="strategyGroup.controls[label]" />
                </c11n-checkbox>
            </c11n-checkbox-group>
            <c11n-checkbox-group *ngIf="productType === '529-portfolios'">
                <c11n-checkbox *ngFor="let label of strategyFilters529" [labelText]="filterMap[label]">
                    <input c11nCheckboxInput [id]="label" type="checkbox" name="choices" [value]="label"
                        [formControl]="strategyGroup529.controls[label]" />
                </c11n-checkbox>
            </c11n-checkbox-group>
        </p>
    </div>

</div>

<c11n-modal-dialog
    modalId="modalId"
    variant="basic"
    headingText="What's a strategy?"
    #simpleModalDialog>
    <div c11n-modal-dialog-body>
      <ng-container *ngIf="productType !== '529-portfolios'; else portfoliosContent">
        <p class="rps-paragraph-one" [innerHTML]="strategyContent"></p>
        <br/>
        <b>All-in-one</b>
        <p class="rps-paragraph-one" [innerHTML]="allInOneContent"></p>
        <br/>
        <b>Total market ETFs</b>
        <p class="rps-paragraph-one" [innerHTML]="totalMarketContent"></p>
        <br/>
        <b>ESG</b>
        <p class="rps-paragraph-one" [innerHTML]="esgContent">.</p>
        <br/>
        <b>Cash</b>
        <p class="rps-paragraph-one" [innerHTML]="cashContent"></p>
      </ng-container>
      <ng-template #portfoliosContent>
        <b>Individual balanced Portfolios</b>
        <p class="rps-paragraph-one" [innerHTML]="individualBalancedContent"></p>
        <br/>
        <b>Target Enrollment Portfolios</b>
        <p class="rps-paragraph-one" [innerHTML]="targetEnrollmentContent"></p>
        <br/>
        <b>Individual Portfolios</b>
        <p class="rps-paragraph-one" [innerHTML]="individualContent"></p>
        <br/>
      </ng-template>
    </div>
</c11n-modal-dialog>